export default "__VITE_ASSET__dYs8i49f__";